import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "副業の可否")
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_section_inner" }
const _hoisted_4 = ["value"]

import { JobSearchPublicDropdownData } from '@/types/mstMyPage';
import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'SideJob',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: number | null
}

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
// 親コンポーネントからのプロパティを定義


// 親コンポーネントへのイベントを定義


const listSideJob = ref<JobSearchPublicDropdownData[]>([]);
const selectedSideJob = ref<string>('');

// 選択値が変更されたときに親コンポーネントに通知する
function emitSelectedValue() {
  emit('update:modelValue', Number(selectedSideJob.value));
}

// propsの値が変更されたときに内部の状態を更新
watch(() => props.modelValue, (newValue) => {
  if (newValue === null || newValue === undefined) {
    selectedSideJob.value = '0';
  } else {
    selectedSideJob.value = String(newValue);
  }
}, { immediate: true });

const store = useStore();
onMounted(async () => {
  const defaultOpt: JobSearchPublicDropdownData = {
    id: 0,
    text: '指定しない',
    value: '0'
  };
  const sideJob = await store.dispatch(storeBase.MST_SIDE_BUSINESS_ORDER);
  listSideJob.value = [defaultOpt, ...sideJob];

  selectedSideJob.value = '';
  // 初期値が設定されていない場合はデフォルト値を使用
  if (!selectedSideJob.value && listSideJob.value.length > 0) {
    if (props.modelValue){
      selectedSideJob.value = String(props.modelValue);
    } else {
      selectedSideJob.value = defaultOpt.value;
    }
    // 初期値を親に通知
    emitSelectedValue();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        class: "p-jobsearch-search_select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSideJob).value = $event)),
        onChange: emitSelectedValue
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listSideJob.value, (job) => {
          return (_openBlock(), _createElementBlock("option", {
            key: job.id,
            value: job.value
          }, _toDisplayString(job.text), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, selectedSideJob.value]
      ])
    ])
  ]))
}
}

})